/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Wins_No_DeckInputs */



/**
* | output |
* | --- |
* | "No decklist on record for these wins. Upload yours so they're kept in the records." |
*
* @param {Profile_Wins_No_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_wins_no_deck = /** @type {((inputs?: Profile_Wins_No_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Wins_No_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune decklist archivée pour ces victoires. Envoyez la vôtre pour qu'elles restent dans les archives.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay decklist archivada para estas victorias. Sube la tuya para que queden en los archivos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma decklist arquivada para estas vitórias. Envie a sua para que fiquem nos arquivos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna decklist archiviata per queste vittorie. Carica la tua perché restino negli archivi.")
	return /** @type {LocalizedString} */ ("No decklist on record for these wins. Upload yours so they're kept in the records.")
});